"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationPin = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var LocationPin = function LocationPin() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M11.6 0A9.6 9.6 0 002 9.6c0 7.463 6.06 7.403 7.511 11.734l.612 1.848a1.2 1.2 0 001.2.816h.672a1.2 1.2 0 001.2-.816l.612-1.848C15.2 17.003 21.2 17.063 21.2 9.6A9.6 9.6 0 0011.599 0zm0 13.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2z"
  });
};

exports.LocationPin = LocationPin;